import { pixelIcons } from '@/game/pixelIcons';
import React from 'react';

// Type-safe icon names
export type PixelIconName = keyof typeof pixelIcons;

export interface PixelIconProps {
  name: PixelIconName;
  size?: number;
  color?: string;
  className?: string;
}

const PixelIcon: React.FC<PixelIconProps> = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
}) => {
  const icon = pixelIcons[name];

  if (!icon) {
    console.warn(`Icon "${name}" not found in pixel icon system`);
    return null;
  }

  return (
    <svg
      className={`pixel-icon pixel-icon-${name} ${className}`}
      width={size}
      height={size}
      viewBox={icon.viewBox}
      fill="none"
      style={{ color }}
    >
      <g dangerouslySetInnerHTML={{ __html: icon.path }} />
    </svg>
  );
};

export default PixelIcon;
